// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"DamageImage_imageWrapper__qJ62U","image":"DamageImage_image__cilTW","marker":"DamageImage_marker__FcevD"};